import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_global/CookieConsent/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/src/components/_global/Mascots/MascotsRender.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/global/global.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/VisualEditing.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../assets/fonts/Lato-Light.woff2\",\"weight\":\"300\",\"style\":\"normal\"},{\"path\":\"../assets/fonts/Lato-LightItalic.woff2\",\"weight\":\"300\",\"style\":\"italic\"}],\"display\":\"swap\",\"fallback\":[\"sans-serif\"]}],\"variableName\":\"Lato\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../assets/fonts/CityStreetwear-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"}],\"display\":\"swap\",\"fallback\":[\"sans-serif\"],\"variable\":\"--font-city-streetwear\"}],\"variableName\":\"CityStreetWear\"}");
